/**
 * Toggle JavaScript
 *
 * Add accessibility and define drop
 * down behavior
 */

// we're using window.xyz to make this globally available to blocks
window.aquaminToggle = (name, opt) => {
	document.querySelectorAll(opt.wrap)?.forEach((wrap, i) => {
		// define unique id prefix
		const id = `${name}-${i}`;
		// get sub elements
		const triggers = wrap.querySelectorAll(opt.triggers);
		const menu = wrap.querySelector(opt.menu);
		// add accessibility to menu
		menu.setAttribute('id', `${id}-menu`);
		// start out with nav hidden at mobile (assumes trigger is only visible at mobile)
		if (triggers[0].offsetParent) {
			menu.setAttribute('aria-hidden', true);
		}
		// for each trigger
		triggers.forEach((trigger) => {
			// add accessibility to this trigger
			trigger.setAttribute('aria-expanded', false);
			trigger.setAttribute('aria-controls', menu.id);

			// on click of the trigger show the menu (with accessibility)
			trigger.addEventListener('click', () => {
				const wasOpen =
					trigger.getAttribute('aria-expanded') === 'true';
				triggers.forEach((el) => {
					el.setAttribute('aria-expanded', !wasOpen);
					el.setAttribute('aria-label', wasOpen ? 'Menu' : 'Close');
				});
				menu.setAttribute('aria-hidden', wasOpen);
			});
		});
	});
};
